import { SidebarNavItem } from './SidebarNavItem.tsx'
import type { NavItem } from '../types.ts'

interface SidebarNavProps {
  items: NavItem[]
  isCollapsed: boolean
  resolvePath: (item: NavItem) => string
}

export function SidebarNav({ items, isCollapsed, resolvePath }: SidebarNavProps) {
  return (
    <nav className="flex flex-1 flex-col gap-1 overflow-y-auto px-3">
      {items.map((item) => (
        <SidebarNavItem
          key={item.key}
          item={item}
          to={resolvePath(item)}
          isCollapsed={isCollapsed}
        />
      ))}
    </nav>
  )
}
